import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";

import styles from "../styles";

interface LeftSideBarIconProps {
  name: string | JSX.Element;
  isActive: boolean;
  onClick: () => void;
  icon: string;
  link: string;
}

function LeftSideBarIcon({
  name,
  icon,
  isActive,
  onClick,
  link,
}: LeftSideBarIconProps) {
  return (
    <Link to={link} style={styles.link}>
      <Box
        display="flex"
        alignItems={"center"}
        flexDirection="column"
        sx={[styles.button, isActive ? styles.active : {}]}
        onClick={onClick}
      >
        <Typography
          textAlign="center"
          gutterBottom
          sx={isActive ? styles.activeText : styles.inactiveText}
        >
          <Box component="i" className={icon} sx={{ fontSize: 16 }} />
        </Typography>

        <Typography
          textAlign="center"
          variant="caption"
          sx={[styles.iconText, isActive ? { color: "white" } : {}]}
        >
          {name}
        </Typography>
      </Box>
    </Link>
  );
}

export default LeftSideBarIcon;
